import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

// Amount Controller
// Manages the amount input field
export default class extends Controller {
  static targets = ["input"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 20000 }
  }

  connect() {
    this.input = this.hasInputTarget ? this.inputTarget : this.element
    if (!this.input) {
      throw new Error("Missing Amount input element")
    }

    this.setupAutoNumeric()
    if (this.input.value === "0.00") {
      this.input.focus()
    }
  }

  disconnect() {
    this.inputMoney.remove()
  }

  // Actions

  // Called when the amount changes
  changed(event) {
    // Dispatch a custom event that other controllers can listen to
    const amountChangedEvent = new CustomEvent("amount:changed", {
      detail: { amount: this.inputMoney.rawValue },
      bubbles: true
    })
    this.element.dispatchEvent(amountChangedEvent)
  }

  // Private
  setupAutoNumeric() {
    this.inputMoney = new AutoNumeric(this.input, {
      digitGroupSeparator: "",
      leadingZero: "deny",
      historySize: 1,
      modifyValueOnWheel: false,
      minimumValue: this.minValue,
      maximumValue: this.maxValue,
      emptyInputBehavior: "null",
      selectOnFocus: true,
      caretPositionOnFocus: null,
      watchExternalChanges: true,
    })
    // this.inputMoney.rawValue returns the numeric value without formatting
  }
}
